import React, { useState } from 'react';
import { ButtonPlate, Container, Description, Text, Span, Title, WrapDescription, TitleModal, TextFooter, ItemListWrap } from '../styled';
import { LinkStyled, Space } from '@gr-monorepo/common/ui';
import ModalContainer from './ModalContainer';
import Modal from './Modal';
import { useClickStreamContext } from 'features/shared/ClickStream';

const link =
  'https://distant.uchi.ru/reading_literacy?utm_source=site&utm_medium=banner&utm_campaign=b2t_chg_pop_up';
  
const messageTextToCopy = (linkUtm: string) =>
  `Здравствуйте! На Учи.ру до 20 января включительно можно зарегистрироваться на курс повышения квалификации для учителей 1–4 классов «Читательская грамотность младшего школьника: особенности формирования и оценки в соответствии с ФГОС НОО и ФОП НОО». \n \nЭксперты — педагоги высшей категории и кандидаты наук, расскажут, как:  \n \n• способствовать развитию функциональной и читательской грамотности; \n• разработать задания и оценить сформированность навыков; \n• подготовиться к исследованию PIRLS; \n• помочь ученикам научиться читать осмысленно. \n \nОбъем материалов — 72 академических часа. При успешном освоении программы слушатели получат удостоверение, зарегистрированное в ФИС ФРДО. \n \nПожалуйста, передайте информацию о курсе учителям и пригласите их записаться: ${linkUtm}`;

const ReadingLiteracyContentModal = ({ linkUtm }: { linkUtm: string }) => {
  return (
    <>
      <TitleModal>
        Скопируйте это сообщение и отправьте <br />
        муниципалитетам:
      </TitleModal>
      <Description>
        <WrapDescription>
          <p> Здравствуйте! На Учи.ру до 20 января включительно можно зарегистрироваться на курс повышения квалификации для учителей <br/> 1–4 классов «Читательская грамотность младшего школьника: особенности формирования и оценки в соответствии с ФГОС НОО и&nbsp;ФОП НОО».</p>
          <div style={{ display: 'grid', gap: '12px' }}>
            <p>Эксперты — педагоги высшей категории и кандидаты наук, расскажут,&nbsp;как:</p>
            <div style={{ display: 'grid', gap: '8px', paddingLeft: '12px' }}>
              <ItemListWrap><span>•</span><p>способствовать развитию функциональной и читательской грамотности;</p></ItemListWrap>
              <ItemListWrap><span>•</span><p>разработать задания и оценить сформированность навыков;</p></ItemListWrap>
              <ItemListWrap><span>•</span><p>подготовиться к исследованию PIRLS;</p></ItemListWrap>
              <ItemListWrap><span>•</span><p>помочь ученикам научиться читать осмысленно.</p></ItemListWrap>
            </div>
          </div>
          <p>
          Объем материалов — 72 академических часа. При успешном освоении программы слушатели получат удостоверение, зарегистрированное в&nbsp;ФИС ФРДО.
          </p>
          <p>
          Пожалуйста, передайте информацию о курсе учителям и пригласите их записаться:
            <LinkStyled style={{ color: '#7F39FB' }} href={linkUtm} target="_blank">
              {' '}
              https://distant.uchi.ru/reading_literacy
            </LinkStyled>
          </p>
        </WrapDescription>
      </Description>
    </>
  );
};
const ReadingLiteracy = ({ id }: { id: number }) => {
  const [isOpenModal, setOpenModal] = useState<boolean>(false);
  const [isCopied, setCopied] = useState<boolean>(false);
  const utm = `&cabmun_id=${id}`;
  const linkUtm = link + utm;
  const { logPageEvent } = useClickStreamContext();

  const handleOpenModal = () => {
    setOpenModal(true);
    logPageEvent?.({
      eventType: 'main_page_info_kpk_reading_literacy',
      eventInfo: 'Клик по кнопке: Поделиться информацией в плашке Читательская грамотность',
    });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCopied(false);
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(messageTextToCopy(linkUtm)).then(() => {
      setCopied(true);
      logPageEvent?.({
        eventType: 'main_page_info_kpk_modal_reading_literacy',
        eventInfo: 'Клик по кнопке: Скопировать в модальном окне Читательская грамотность',
      });
    });
  };
  return (
    <>
      <Container>
        <WrapDescription>
          <Title>Бесплатный курс повышения квалификации Учи.ру для педагогов 1-4 классов</Title>
          <Text>Читательская грамотность младшего школьника: особенности формирования и&nbsp;оценки в соответствии с ФГОС НОО и&nbsp;ФОП&nbsp;НОО</Text>
          <Text>Программа разработана Мариной Ивановной Кузнецовой, ведущим научным сотрудником лаборатории начального общего образования Института стратегии развития образования РАО.</Text>
          <Text>Педагоги региона узнают, как создавать упражнения для развития навыков чтения, проектировать уроки и формировать читательскую грамотность с помощью интерактивных заданий Учи.ру.</Text>
        </WrapDescription>
        <div>
          <ButtonPlate color={'violet'} onClick={handleOpenModal}>
            Поделиться информацией о курсе
          </ButtonPlate>
          <Space size={16} axis="vertical" />
          <TextFooter>За успешное освоение программы выдается удостоверение, зарегистрированное в ФИС ФРДО.</TextFooter>
        </div>
      </Container>

      {isOpenModal && (
        <ModalContainer onClose={handleCloseModal}>
          <Modal isCopied={isCopied} onClick={handleCopyClick}>
            <ReadingLiteracyContentModal linkUtm={linkUtm} />
          </Modal>
        </ModalContainer>
      )}
    </>
  );
};

export default ReadingLiteracy;
